module.exports = __webpack_public_path__ + "img/btn1.736b0bc6.png";